define.alias("shared/components/shared/ui/group-avatar", "settings/components/shared/ui/group-avatar");